<template>
  <v-menu
    v-model="open"
    full-width
  >
    <template v-slot:activator="{ on }">
      <v-chip
        text-color="white"
        small
        :color="color"
        class="item"
        v-on="on"
      >
        <v-avatar class="scale" :color="scaleColor(item.scale)">
          {{ item.scale.charAt(0) }}
        </v-avatar>
        {{ item.name }} | {{ item.planned_processes }} | {{ item.planned_recipes }}
      </v-chip>
    </template>
    <v-card color="grey lighten-4" min-width="350px" flat>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>
          {{ item.name }} ({{ item.status.replace(/\_/g, '&nbsp;') }})
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title primary-title>
        <ul>
          <li>
            <b>Project name:</b>
            <em> {{ item.project.name }}</em>
          </li>
          <li>
            <b>Initiator:</b>
            <em> {{ item.initiator.username }}</em>
          </li>
          <li>
            <b>Plant:</b>
            <em> {{ item.plant.name }}</em>
          </li>
          <li>
            <b>Scheduled date:</b>
            <em> {{ item.scheduled_date_rng.from.value }} - {{ item.scheduled_date_rng.to.value }}</em>
          </li>
          <li>
            <b>Planning date:</b>
            <em> {{ item.planning_date_rng.from.value }} - {{ item.planning_date_rng.to.value }}</em>
          </li>
          <li>
            <b>Processes:</b>
            <em> {{ item.planned_processes }}</em>
          </li>
          <li>
            <b>Recipes:</b>
            <em> {{ item.planned_recipes }}</em>
          </li>
        </ul>
      </v-card-title>
      <v-card-actions>
        <v-container fluid grid-list-xl class="pt-0">
          <v-layout wrap align-top justify-end>
            <v-btn small color="error">
              Cancel
            </v-btn>
            <v-btn small @click="showItem()" color="warning">
              More
            </v-btn>
          </v-layout>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'dateItem',
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      open: false,
      COLOR: {
        trial: 'primary',
        booking: 'grey',
      },
    };
  },
  computed: {
    color() {
      const { COLOR, item: { type } } = this;
      return COLOR[type];
    },
  },
  methods: {
    scaleColor(currentScale) {
      return this.SCALE.find(scale => scale.name === currentScale).color;
    },
    showItem({ edit = false } = {}) {
      const { item: { id, type } } = this;
      this.$router.push({
        name: this.allRoutes[type].children[`${ type }Detail`].name,
        params: edit ? {
          id,
          from: this.$route.name,
          editMode: edit,
        } : {
          id,
          from: this.$route.name,
        },
      });
    },
  },
};
</script>
